import React from 'react';
import {AsyncComponent} from "../../../../components/router/async-component";

const DebugModuleAsyncComponent = AsyncComponent(async () => import('./debug-module' /* webpackChunkName: "debug-module" */ ));

export const DebugModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <DebugModuleAsyncComponent {...props}/>
  </React.Suspense>
}
